import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

function PageHero({ kicker, title, subtitle }) {
  return (
    <div className="bg-[#111827] py-16">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 text-center">
        <p className="text-xs font-bold text-[#C5A059] uppercase tracking-[0.15em]">{kicker}</p>
        <h1 className="mt-3 font-display text-4xl sm:text-5xl font-bold text-white tracking-tight">{title}</h1>
        {subtitle && <p className="mt-4 text-lg text-white/80">{subtitle}</p>}
      </div>
    </div>
  );
}

export default function About() {
  return (
    <div>
      <PageHero kicker="About Homio" title="An independent property referral platform" subtitle="Connecting buyers and tenants with trusted agencies and property partners across the UK." />
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14 prose prose-lg text-[#111827]/80">
        <p>Homio is an independent property referral and introduction platform. We showcase homes for sale and to let that are supplied by estate agents, letting agencies, property developers, landlords and other property partners.</p>
        <h2 className="font-display text-[#111827]">What we do</h2>
        <p>We advertise available properties, help you search and filter to find the right home, and collect your enquiry. We then refer that enquiry to the relevant agency or property partner, who will contact you directly to take things forward.</p>
        <h2 className="font-display text-[#111827]">What we don't do</h2>
        <p>Homio does not directly sell, let, manage, value or negotiate properties. We are not the estate agent responsible for any transaction. The relevant property partner handles all direct communication, viewings and negotiations. Where an enquiry results in a successful transaction, Homio may receive a referral fee or commission.</p>
        <p>Property information is supplied by third parties and should be independently verified. Availability, prices, measurements, images, tenure and descriptions are not guaranteed.</p>
      </div>
      <div className="max-w-4xl mx-auto px-5 pb-16 text-center">
        <Link to="/properties"><Button className="rounded-full bg-[#C81D35] hover:bg-[#a5162b] px-8 h-12">Browse properties</Button></Link>
      </div>
    </div>
  );
}

export { PageHero };
